/* Salaise Print Studio V9 — recommandations via l'API officielle Shopify */
(function () {
  'use strict';
  function loadRecommendations(node) {
    if (!node || node.dataset.spsV9Loaded === 'yes') return;
    var endpoint = node.getAttribute('data-sps-v9-reco-url');
    if (!endpoint) return;
    node.dataset.spsV9Loaded = 'yes';
    fetch(endpoint, {credentials: 'same-origin'})
      .then(function (response) { if (!response.ok) throw new Error('HTTP '+response.status); return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var replacement = doc.getElementById(node.id);
        var content = replacement && replacement.querySelector('[data-sps-v9-reco-content]');
        if (content && content.querySelector('.sps-v9-reco-card')) {
          node.innerHTML = '';
          node.appendChild(document.importNode(content, true));
        } else {
          node.remove();
        }
      })
      .catch(function () { node.remove(); });
  }
  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-sps-v9-reco-url]');
    Array.prototype.forEach.call(nodes, loadRecommendations);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e) { init(e.target); });
}());
